import { List, Typography, Box, Button } from '@mui/material'
import NotificationItem from './NotificationItem'
import { sectionTitleStyle } from '../../../helpers/utils'

export default function NotificationList({
  newNotifs,
  olderNotifs,
  onMarkRead,
  onMarkAllRead,
}) {
  const handleMarkAllTodayRead = () => {
    const unreadTodayNotifs = newNotifs.filter(
      (notification) => !notification.read
    )
    if (unreadTodayNotifs.length > 0 && onMarkAllRead) {
      onMarkAllRead(unreadTodayNotifs)
    }
  }

  const handleMarkAllOlderRead = () => {
    const unreadOlderNotifs = olderNotifs.filter(
      (notification) => !notification.read
    )
    if (unreadOlderNotifs.length > 0 && onMarkAllRead) {
      onMarkAllRead(unreadOlderNotifs)
    }
  }

  const unreadTodayCount = newNotifs.filter(
    (notification) => !notification.read
  ).length
  const unreadOlderCount = olderNotifs.filter(
    (notification) => !notification.read
  ).length
  return (
    <List>
      {newNotifs.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            py: 2,
            ...sectionTitleStyle,
          }}
        >
          <Typography
            sx={{
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              color: '#757575',
            }}
          >
            Today
          </Typography>
          {unreadTodayCount > 0 && (
            <Button
              size="small"
              onClick={handleMarkAllTodayRead}
              sx={{
                fontSize: '0.75rem',
                textTransform: 'none',
                color: 'white',
                backgroundColor: '#cc0000',
                minWidth: 'auto',
                padding: '4px 8px',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: '#aa0000',
                },
              }}
            >
              Mark all as read
            </Button>
          )}
        </Box>
      )}
      {newNotifs.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onMarkRead={onMarkRead}
        />
      ))}

      {olderNotifs.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            py: 1,
            ...sectionTitleStyle,
          }}
        >
          <Typography
            sx={{
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              color: '#757575',
            }}
          >
            Older Notifications
          </Typography>
          {unreadOlderCount > 0 && (
            <Button
              size="small"
              onClick={handleMarkAllOlderRead}
              sx={{
                fontSize: '0.75rem',
                textTransform: 'none',
                color: 'white',
                backgroundColor: '#cc0000',
                minWidth: 'auto',
                padding: '4px 8px',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: '#aa0000',
                },
              }}
            >
              Mark all as read
            </Button>
          )}
        </Box>
      )}

      {olderNotifs.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onMarkRead={onMarkRead}
        />
      ))}
    </List>
  )
}
